import { useContext, useEffect, useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import AsyncCreatableSelect from "react-select/async-creatable";
import GlobalContext from "../context/GlobalContext";
import { fetchDepartmentSuggestions } from "../api/UsersApi";

import { tr } from "../i18n";
const DepartementSelect = (props) => {
  const { user } = useContext(GlobalContext);
  const { control, register, setValue } = useFormContext();
  const [cachedOptions, setCachedOptions] = useState([]);

  const name = props.name || "department";

  useEffect(() => {
    register(name, { required: props.rules?.required });
  }, [name, props.rules?.required, register]);

  const loadOptions = async (inputValue = "") => {
    const companyId = user?.workspace?.company_id;
    if (!companyId) {
      return [];
    }

    const response = await fetchDepartmentSuggestions(companyId, inputValue);
    const suggestions = response?.data || [];

    setCachedOptions((prev) => {
      const merged = [...prev, ...suggestions];
      return merged.filter(
        (item, index, array) =>
          array.findIndex((x) => x.value === item.value) === index,
      );
    });

    return suggestions;
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const selectedOption = field.value
          ? cachedOptions.find((opt) => opt.value === field.value) || {
              value: field.value,
              label: field.value,
            }
          : null;

        return (
          <AsyncCreatableSelect
            value={selectedOption}
            loadOptions={loadOptions}
            defaultOptions={cachedOptions}
            placeholder={props.placeholder || tr("users:select_or_type_department")}
            className={props.className}
            isClearable
            onMenuOpen={() => {
              loadOptions("");
            }}
            onCreateOption={(inputValue) => {
              const newOption = { value: inputValue, label: inputValue };
              setCachedOptions((prev) => {
                if (prev.some((item) => item.value === newOption.value)) {
                  return prev;
                }
                return [...prev, newOption];
              });
              setValue(name, inputValue, {
                shouldValidate: true,
                shouldDirty: true,
              });
            }}
            onChange={(selected) => {
              setValue(name, selected ? selected.value : null, {
                shouldValidate: true,
                shouldDirty: true,
              });
            }}
            noOptionsMessage={() => "No matching department"}
            formatCreateLabel={(inputValue) => `Use \"${inputValue}\"`}
          />
        );
      }}
    />
  );
};

export default DepartementSelect;
